import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import { CustomTrans } from '../../../translation/CustomTrans';

export function AssessmentNormativesPage() {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h5">
        {t('assessment.ASSESSMENT_NORMATIVES_TITLE')}
      </Typography>
      <Grid sx={{ my: 2 }}>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t('assessment.ID_GLASGOW_COMA_SCALE_TITLE_ASSESSMENT_PRIMARY')}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_GLASGOW_COMA_SCALE" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t('assessment.ID_IMMEDIATE_MEMORY_TITLE_ASSESSMENT_PRIMARY')}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_IMMEDIATE_MEMORY" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t('assessment.ID_SYMPTOM_CHECKLIST_PRIMARY')}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_SYMPTOM_CHECKLIST" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t('assessment.ID_DIGITS_BACKWARDS_ASSESSMENT_PRIMARY')}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_DIGITS_BACKWARDS" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t('assessment.ID_MONTHS_IN_REVERSE_ASSESSMENT_PRIMARY')}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_MONTHS_IN_REVERSE" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t(
              'assessment.ID_BALANCE_TANDEM_GAIT_TITLE_BALANCE_ASSESSMENT_PRIMARY',
            )}
            :{' '}
            {t(
              'assessment.ID_BALANCE_TANDEM_GAIT_TITLE_BALANCE_ASSESSMENT_SUB',
            )}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_TANDEM_GAIT" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t(
              'assessment.ID_BALANCE_DOUBLE_LEG_STANCE_TITLE_BALANCE_ASSESSMENT_PRIMARY',
            )}
            :{' '}
            {t(
              'assessment.ID_BALANCE_DOUBLE_LEG_STANCE_TITLE_BALANCE_ASSESSMENT_SUB',
            )}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_BALANCE_DOUBLE_LEG_STANCE" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t(
              'assessment.ID_BALANCE_SINGLE_LEG_STANCE_TITLE_BALANCE_ASSESSMENT_PRIMARY',
            )}
            :{' '}
            {t(
              'assessment.ID_BALANCE_SINGLE_LEG_STANCE_TITLE_BALANCE_ASSESSMENT_SUB',
            )}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_BALANCE_SINGLE_LEG_STANCE" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t(
              'assessment.ID_BALANCE_TANDEM_STANCE_TITLE_BALANCE_ASSESSMENT_PRIMARY',
            )}
            :{' '}
            {t(
              'assessment.ID_BALANCE_TANDEM_STANCE_TITLE_BALANCE_ASSESSMENT_SUB',
            )}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_BALANCE_TANDEM_STANCE" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t('assessment.ID_DELAYED_RECALL_ASSESSMENT_PRIMARY')}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_DELAYED_RECALL" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t('assessment.ID_NECK_EXAM_TITLE_ASSESSMENT_PRIMARY')}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_NECK_EXAM" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t('assessment.ID_NEURO_EXAM_TITLE_ASSESSMENT_PRIMARY')}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_NEURO_EXAM" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t('assessment.ID_VOMS_TITLE_ASSESSMENT_PRIMARY')}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_VOMS" />
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography fontWeight="bold" sx={{ mb: 1 }}>
            {t('assessment.ID_TREATMENT_PLAN_ASSESSMENT_PRIMARY')}
          </Typography>

          <CustomTrans i18nKey="assessment.ASSESSMENT_NORMATIVES_DETAIL_TREATMENT_PLAN" />
        </Grid>
      </Grid>
    </>
  );
}
